"use strict";
exports.__esModule = true;
exports.toThemeColor = void 0;
var types_1 = require("../../types");
var THEMECOLOR_PRISMIC_TO_LGLP = {
    'BG Bleu, accentuation turquoise': types_1.ThemeColor.BlueTitleTurquoise,
    'BG Bleu, accentuation jaune': types_1.ThemeColor.BlueTitleYellow,
    'BG Jaune': types_1.ThemeColor.Yellow,
    'BG Rouge': types_1.ThemeColor.Red,
    'BG Turquoise': types_1.ThemeColor.Turquoise
};
var toThemeColor = function (prismicThemeColor, logger) {
    return logger.toConstValue(prismicThemeColor, THEMECOLOR_PRISMIC_TO_LGLP);
};
exports.toThemeColor = toThemeColor;
//# sourceMappingURL=theme-colors.js.map